<template>
  <div class="columns has-padding-top-md">
    <div class="column is-6">
      <b-field grouped>
        <p class="control">
          <strong v-t="'was_helpful'" />
        </p>
        <p class="control">
          <button type="button" class="button is-small is-rounded" @click="isHelpful($event, true)">
            <span v-t="'btn_yes'" />
          </button>
        </p>
        <p class="control">
          <button type="button" class="button is-small is-rounded" @click="isHelpful($event, false)">
            <span v-t="'btn_no'" />
          </button>
        </p>
      </b-field>

      <form class="feedback-form">
        <b-field :label="$t('feedback_form_title')">
          <b-input type="textarea" v-model="feedback" />
        </b-field>
        <button type="submit" class="button is-danger" @click.prevent="sendFeedback($event)">
          <b-icon icon="paper-plane" size="is-small" />
          <span v-t="'send_feedback'" />
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import API from '@/api'

export default {
  name: 'ArticleFeedback',
  props: { article: { type: Number, required: true } },
  data () {
    return {
      sent: false,
      feedback: ''
    }
  },
  methods: {
    isHelpful (event, isHelpful) {
      if (!this.sent) {
        let btn = event.currentTarget

        if (isHelpful) {
          btn.classList.add('is-success')
          this.$snotify.success(this.$t('thanks_message'), this.$t('thanks_title'))
        } else {
          btn.classList.add('is-danger')
          let form = document.querySelector('.feedback-form')
          form.style.height = this.getHeight(form)
          form.classList.add('is-visible')
        }

        this.sent = true
      }
    },
    getHeight (elem) {
      elem.style.display = 'block'
      let height = elem.scrollHeight + 'px'
      elem.style.display = ''

      return height
    },
    sendFeedback (event) {
      let btn = event.currentTarget
      let form = document.querySelector('.feedback-form')
      let user = this.$auth.user()

      btn.classList.add('is-loading')

      API.feedback.send({
        name: user.name,
        email: user.email,
        enterprise: user.enterprise,
        message: this.feedback,
        url: window.location.origin + this.$route.path
      }, () => {
        form.style.height = 0
        this.$snotify.success(this.$t('thanks_message'), this.$t('thanks_title'))
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.feedback-form
  display: none
  height: 0
  overflow: hidden
  transition: height 350ms ease-in-out

  &.is-visible
    display: block
    height: auto
</style>

<i18n>
{
  "en-US": {
    "was_helpful": "Was this article helpful?",
    "btn_yes": "Yes",
    "btn_no": "No",
    "thanks_title": "Thanks",
    "thanks_message": "Thanks for your feedback.",
    "feedback_form_title": "Tell us what your question:",
    "send_feedback": "Send feedback"
  },
  "pt-BR": {
    "was_helpful": "Este artigo foi útil para você?",
    "btn_yes": "Sim",
    "btn_no": "Não",
    "thanks_title": "Obrigado",
    "thanks_message": "Agradecemos pelo seu feedback.",
    "feedback_form_title": "Conte-nos qual a sua dúvida:",
    "send_feedback": "Enviar feedback"
  }
}
</i18n>
